<script>
  import PolicialService from '../../../../../domain/policia-civil/policial/services/policial'
  import { isArray } from 'lodash'
  import { mapGetters } from 'vuex'
  import ACL from '../../../../../domain/acl/tmp-acl'

  export default {
    components: {},
    nome: 'nova-policial',
    props: {
      viewerMode: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        loadTiposText: 'Carregando',
        data: {
          id: null,
          nome: null,
          matricula: null,
          telefone: null,
          recebedorPatio: false,
          tipoPolicial: null,
          ativo: false,
          uf: null
        },
        tiposPolicial: [],
        ufs: [],
        selectUf: false
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser']),
      ACL () {
        return ACL
      }
    },
    created () {
      this.start()
      if (ACL.check('coordES', this.currentUser.id)) {
        // Espirito santo
        this.data.uf = 8
      }
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        this.tipos()
        this.unidadesFederativas()
        if (this.$route.params.id && !this.viewerMode) {
          this.$loaderOverlay.open().message('Carregando')
          PolicialService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.data.uf = response.data.uf.id
              this.ajustaValores()
              console.log(response)
            })
              .catch((response) => {
                this.$loaderOverlay.hide()
                console.log(response)
              })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      tipos () {
        this.tiposPolicial = null
        PolicialService.tipos(this.data.uf).then((response) => {
          this.loadTiposText = 'Selecione'
          console.log('data')
          console.log(response.data.tipos_policial)
          this.tiposPolicial = response.data.tipos_policial
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      unidadesFederativas () {
        this.ufs = null
        PolicialService.unidadesFederativas().then((response) => {
          this.loadTiposText = 'Selecione'
          if (this.data.uf === null) {
            this.ufs = response.data
          } else {
            let uf = response.data.find(element => element.id === this.data.uf)
            this.ufs = [uf]
          }
        })
          .catch((response) => {
            this.loadTiposError = true
            this.loadTiposText = 'Erro'
            console.log(response)
          })
      },
      ajustaValores (inversed) {
        inversed = inversed || false
        if (inversed) {
          console.log('Inversed fields to data')
        } else {
          this.data.tipoPolicial = (typeof this.data.tipoPolicial['id'] !== 'undefined') ? this.data.tipoPolicial['id'] : this.data.tipoPolicial
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        PolicialService.cadastrar(this.data, !this.viewerMode && this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.viewerMode) {
              this.$emit('finishSubmit')
              return
            }
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      editarUsuario () {
        if (!this.data.usuario) {
          this.$router.push({name: 'usuario.novo', query: {policial: this.data.id}})
        } else {
          this.$router.push({name: 'usuarios.visualizar', params: {id: this.data.usuario.id}})
        }
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Policial</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'policiacivil.policia.policial.list'}"
                         class="pull-right hidden-print" style="clear: left" v-if="!viewerMode">
              <strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
            <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1" @click.prevent="editarUsuario" v-if="data.id">
              <i class="fa fa-user-o m-r-xs"></i> {{!data.usuario ? 'Criar ' : ''}} Acesso
            </u-button>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Matrícula</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.matricula"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Telefone</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.telefone"/>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">Recebedor no pátio</label>
                <div class="col-sm-8">
                  <input id="tipo-impeditiva" type="checkbox" v-model="data.recebedorPatio"/>
                </div>
              </div>
              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">UF</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.uf" required>
                    <option disabled value="">{{loadTiposText}}</option>
                    <option v-for="uf in ufs" v-bind:value="uf.id">
                      {{ uf.sigla }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo de policial</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.tipoPolicial">
                    <option disabled value="">{{loadTiposText}}</option>
                    <option v-for="tipoPolicial in tiposPolicial" v-bind:value="tipoPolicial.id">
                      {{ tipoPolicial.nome }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label for="tipo-impeditiva" class="col-sm-4 control-label">Ativo</label>
                <div class="col-sm-8">
                  <input id="tipo-impeditiva" type="checkbox" v-model="data.ativo"/>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.policials.list'})" v-if="!viewerMode">
                  Cancelar
                </u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoPolicial.vue?66f10371